<template>
    <div>
        <app-input id="code" v-model="form.code" name="code" rules="required">
            <template #label>
                {{ $t('Code') }}*
            </template>
        </app-input>
        <app-input id="discount_percent" v-model="form.discount_percent" type="number" max="100" name="discount_percent" rules="required">
            <template #label>
                {{ $t('Discount') }} %*
            </template>
        </app-input>
        <app-datepicker v-model="form.start_date">
            <template #label>
                {{ $t('Start') }}
            </template>
        </app-datepicker>
        <app-datepicker v-model="form.end_date">
            <template #label>
                {{ $t('End') }}
            </template>
        </app-datepicker>
    </div>
</template>

<script>
export default {
    name: 'PromocodeForm',
    props: {
        form: Object
    }
};
</script>
